import { useContext } from 'react';

import { FleetsContext } from '../context';
import { FleetsContextProps } from '../context/types';

export function useAnalyticsFleets(): FleetsContextProps {
    return useContext(FleetsContext);
}
